import { render, staticRenderFns } from "./TaskDocuments.vue?vue&type=template&id=b247ab48&scoped=true&"
import script from "./TaskDocuments.vue?vue&type=script&lang=js&"
export * from "./TaskDocuments.vue?vue&type=script&lang=js&"
import style0 from "./TaskDocuments.vue?vue&type=style&index=0&id=b247ab48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b247ab48",
  null
  
)

export default component.exports
import {QScrollArea} from 'quasar'
component.options.components = Object.assign({QScrollArea}, component.options.components || {})
